export default __webpack_public_path__ + "static/BannerGenericImageTextActionWithTitle_Dark-107c9290a8b96cb0a2cd4f2ce363d039.jpg";